export default {
      id: "remove-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "sprite-46b249.svg#remove-usage",
      toString: function () {
        return this.url;
      }
    }